/** Mostrata mentre si verifica se esiste già una sessione. */
export function Splash() {
  return (
    <div
      style={{
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--surface-accent)",
      }}
    >
      <div
        style={{
          fontFamily: "var(--font-display)",
          fontSize: 30,
          fontWeight: 600,
          letterSpacing: "-0.03em",
          color: "var(--text-on-lime)",
        }}
      >
        Qota
      </div>
    </div>
  );
}
